export default function Footer() {
  return (
    <footer id="footer" className="bg-gray-900 text-gray-400">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="py-12 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div className="sm:col-span-2 lg:col-span-1">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 rounded-lg bg-red-600 flex items-center justify-center">
                  <i className="ri-movie-2-line text-white text-base"></i>
                </div>
                <span className="text-white font-bold text-lg">91年国产影片</span>
              </div>
              <p className="text-sm leading-relaxed mb-4">
                专业的91免费在线视频平台，提供91精品视频在线播放、91在线观看免费等高清国产影片资源。覆盖91免费视频网站、91麻豆免费视频网站等渠道，每日更新91福利在线视频内容，致力于打造最好的91免费看视频与91在线免费播放体验。
              </p>
              <div className="flex items-center gap-3">
                <a href="#contact" onClick={(e) => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); }} className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center hover:bg-red-600 transition-colors cursor-pointer">
                  <i className="ri-wechat-line text-white text-sm"></i>
                </a>
                <a href="#contact" onClick={(e) => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); }} className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center hover:bg-red-600 transition-colors cursor-pointer">
                  <i className="ri-mail-line text-white text-sm"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-white font-semibold text-sm mb-4">快速导航</h4>
              <nav className="flex flex-col gap-2.5">
                {[
                  { label: '精选推荐', href: '#media' },
                  { label: '主题索引', href: '#index' },
                  { label: '热门话题', href: '#topics' },
                  { label: '影视资讯', href: '#cards' },
                  { label: '热播榜单', href: '#ranking' },
                ].map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-sm hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {link.label}
                  </a>
                ))}
              </nav>
            </div>

            <div>
              <h4 className="text-white font-semibold text-sm mb-4">关于平台</h4>
              <nav className="flex flex-col gap-2.5">
                {[
                  { label: '关于我们', href: '#about' },
                  { label: '联系我们', href: '#contact' },
                  { label: '常见问题', href: '#faq' },
                  { label: '最新动态', href: '#updates' },
                  { label: '平台特色', href: '#features' },
                ].map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-sm hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {link.label}
                  </a>
                ))}
              </nav>
            </div>

            <div>
              <h4 className="text-white font-semibold text-sm mb-4">合作伙伴</h4>
              <div className="flex flex-col gap-2.5">
                <p className="text-sm text-gray-500 italic">合作伙伴信息持续更新中</p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-gray-500">
            &copy; 2024-2026 91年国产影片视频. 本站所有内容仅供学习交流使用.
          </p>
          <p className="text-xs text-gray-600">
            91免费在线视频 · 91精品视频在线播放 · 高清不缓冲
          </p>
        </div>
      </div>
    </footer>
  );
}